export default __webpack_public_path__ + "static/media/form-contact.12875650.jpg";